import { memo, useRef } from "react";
import { Object3D } from "three";
import { useRoomSizes } from "../../hooks";

const AMBIENT_LIGHT_DEFAULTS = {
    intensity: 1.2,
};

const SPOT_LIGHT_DEFAULTS = {
    color: 0xffffff,
    angle: Math.PI / 3,
    penumbra: 1,
    decay: 2,
    castShadow: true,
};

const createSpotLight = (position: number[], target: number[], targetRef: any, intensity: number, distance: number) => (
  <>
      <spotLight {...SPOT_LIGHT_DEFAULTS} distance={distance} intensity={intensity} position={position as any} target={targetRef.current} />
      <primitive object={targetRef.current} position={target} />
  </>
);

export const Lights = memo(() => {
    const lightTarget0 = useRef(new Object3D());
    const lightTarget1 = useRef(new Object3D());
    const lightTarget2 = useRef(new Object3D());
    const lightTarget3 = useRef(new Object3D());
    const lightTarget4 = useRef(new Object3D());

    const lightTargets = [lightTarget0, lightTarget1, lightTarget2, lightTarget3, lightTarget4];

    const { roomDepth, roomLength, roomHeight } = useRoomSizes();

    const lightPositions = [
        [0, roomHeight / 1000 * 2, roomDepth / 1000 / 2],
        [0, roomHeight / 1000 * 2, roomDepth / 1000 / 2],

        [0, roomHeight / 1000 * 2, roomDepth / 1000 / 2],
        [0, roomHeight / 1000 * 2, roomDepth / 1000 / 2],

        [0, roomHeight / 1000, roomDepth / 2000],
    ];

    const targetPositions = [
        [0, 0, 0],
        [0, 0, roomDepth / 1000],

        [-roomLength / 2000, 0, roomDepth / 2000],
        [roomLength / 2000, 0, roomDepth / 2000],

        [0, 0, roomDepth / 2000],
    ];

    return (
      <>
          <ambientLight {...AMBIENT_LIGHT_DEFAULTS} />
          {lightPositions.map((position, index) => {
              const [px, py, pz] = position;
              const [tx, ty, tz] = targetPositions[index];
              const distance = Math.sqrt((px - tx) ** 2 + (py - ty) ** 2 + (pz - tz) ** 2);
              return createSpotLight(position, targetPositions[index], lightTargets[index], 1, distance * 1.8);
          })}
      </>
    );
});
